import clsx from 'clsx';
import { useId } from 'react';

interface Props {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  color?: 'default' | 'green' | 'orange';
}

const colorClasses = {
  default: {
    checkbox: {
      enabled: 'text-primary-600 focus:ring-primary-500',
      disabled: 'text-primary-300 dark:text-primary-400 disabled:bg-gray-100',
    },
    label: {
      enabled: 'text-gray-700 dark:text-dark-text',
      disabled: 'text-gray-400 dark:text-gray-500',
    },
  },
  green: {
    checkbox: {
      enabled: 'text-green-400 focus:ring-green-400',
      disabled: 'text-green-300 dark:text-green-400 disabled:bg-green-300/50',
    },
    label: {
      enabled: 'text-green-400 dark:text-green-400',
      disabled: 'text-green-300 dark:text-green-300',
    },
  },
  orange: {
    checkbox: {
      enabled: 'text-orange-300 focus:ring-orange-400',
      disabled:
        'text-orange-300 dark:text-orange-400 disabled:bg-orange-300/50 dark:disabled:bg-orange-400/70',
    },
    label: {
      enabled: 'text-orange-400 dark:text-orange-400',
      disabled: 'text-orange-300 dark:text-orange-300',
    },
  },
};

export function Checkbox(props: Props) {
  const {
    label,
    checked,
    disabled = false,
    onChange,
    color = 'default',
  } = props;
  const id = useId();

  const selectedCheckboxClasses = disabled
    ? colorClasses[color].checkbox.disabled
    : colorClasses[color].checkbox.enabled;

  const selectedLabelClasses = disabled
    ? colorClasses[color].label.disabled
    : colorClasses[color].label.enabled;

  return (
    <div className="flex items-start">
      <div className="flex h-5 items-center">
        <input
          id={id}
          type="checkbox"
          className={clsx(
            'focus:ring-offset-dark-bg h-4 w-4 rounded border-gray-300  dark:border-gray-600 dark:disabled:bg-gray-600',
            selectedCheckboxClasses,
            !checked && 'dark:bg-dark-bg'
          )}
          checked={checked}
          onChange={(e) => onChange && onChange(e.target.checked)}
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      {label && (
        <div className="ml-3 text-sm">
          <label htmlFor={id} className={selectedLabelClasses}>
            {label}
          </label>
        </div>
      )}
    </div>
  );
}

export default Checkbox;
